import React from 'react';
import cx from 'classnames';
import { get } from 'lodash';
import createPersistedState from '~/react-hooks/use-persisted-state';

import { assetUrl } from '~/helpers';
import useCurrentUser from '~/react-hooks/use-current-user';
import { default as ProtipRollupModal } from '~/App/Components/Modals/ProtipRollup';

const useRollupModalOpenedList = createPersistedState('protip-roll-up-opened');

export type ProTipRollupProps = {
  className?: string;
};

export default function ProTipRollup({ className }: ProTipRollupProps) {
  const user = useCurrentUser();
  const [openedList, setOpenedList] =
    useRollupModalOpenedList<Record<string, number>>();
  const userId: string = user.id || '';

  const addUserToOpenedList = () => {
    const userLoginCount = get(openedList, userId, 0);
    setOpenedList({
      ...openedList,
      [userId]: userLoginCount + 1,
    });
  };

  const handleProtipRollUpClick = (
    evt: React.MouseEvent<HTMLAnchorElement>
  ) => {
    window.dispatchEvent(new Event('protip-rollup-modal::open'));
    evt.preventDefault();
  };

  // Do not display when clicked more than 5 times
  if (get(openedList, userId, 0) >= 5) {
    return null;
  }

  return (
    <div className={cx('flex justify-center text-center', className)}>
      <a className='text-nowrap' onClick={handleProtipRollUpClick} href='#'>
        <img
          src={assetUrl('assets/images/icons/magic-wand.svg')}
          width='18'
          height='21'
        />{' '}
        Pro tip
      </a>{' '}
      - Send a group message with roll-ups
      <ProtipRollupModal onConfirm={addUserToOpenedList} />
    </div>
  );
}
